<template>
  <AuthPage :page="$page" type="login" />
</template>

<script>
import { AuthPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'AuthLogin',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_login',
  components: { AuthPage },
}
</script>
